// Lib
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import { compose } from '../../../../node_module_clones/recompose';

// Utils
import { isStartEdge, isEndEdge } from '../utils/lineUtil';
import { getLineHandleMode } from '../utils/lineHandleUtil';

// Selectors
import { getElementId, getColourHex, isElementSelectedSelector } from '../../selectors/elementSelector';
import { getDraggedLineEdgesPx } from '../lineEdgeSelector';
import {
    getLineStartStyleSelector,
    getLineEndStyleSelector,
    getIsLineStartSnappedSelector,
    getIsLineEndSnappedSelector,
} from '../lineSelector';

// Components
import Line from '../Line';
import LineEdgeSnapPointGuide from './LineEdgeSnapPointGuide';

// Measurements
import measurementsConnect from '../../../components/measurementsStore/measurementsConnect';
import { getShallowMeasurementsMap } from '../../../components/measurementsStore/elementMeasurements/elementMeasurementsSelector';

// PERF: Don't need to connect to the specific measurements here, because they shouldn't change during the drag
const mapMeasurementsStateToProps = (connectionsState) => ({
    measurements: getShallowMeasurementsMap(connectionsState),
});

const makeMapStateToProps = () =>
    createSelector(
        getElementId,
        isElementSelectedSelector(),
        getDraggedLineEdgesPx,
        getColourHex(),
        getLineStartStyleSelector,
        getLineEndStyleSelector,
        getIsLineStartSnappedSelector,
        getIsLineEndSnappedSelector,
        (state, ownProps) => ownProps.draggedEdge,
        (
            elementId,
            isSelected,
            lineDetails,
            colorHex,
            startStyle,
            endStyle,
            startSnapped,
            endSnapped,
            draggedEdge,
        ) => ({
            elementId,
            isSelected,
            ...lineDetails,
            colorHex,
            startStyle,
            endStyle,
            controlHandleMode: getLineHandleMode({ forceShow: true }),
            startHandleMode: getLineHandleMode({
                isDragging: isStartEdge(draggedEdge),
                forceShow: true,
                snapped: startSnapped && !isStartEdge(draggedEdge),
                snappedToGuide: !!lineDetails.start?.snappedToGuide,
                longHover: lineDetails.isConnectInsideMode && isStartEdge(draggedEdge),
            }),
            endHandleMode: getLineHandleMode({
                isDragging: isEndEdge(draggedEdge),
                forceShow: true,
                snapped: endSnapped && !isEndEdge(draggedEdge),
                snappedToGuide: !!lineDetails.end?.snappedToGuide,
                longHover: lineDetails.isConnectInsideMode && isEndEdge(draggedEdge),
            }),
        }),
    );

const enhance = compose(measurementsConnect(mapMeasurementsStateToProps), connect(makeMapStateToProps));

const LineEdgeDragPreview = (props) => (
    <>
        <Line {...props} showEndGhost showStartGhost isPresentational />
        <LineEdgeSnapPointGuide dropPosition={props.dropPosition} snapPoints={props.snapPoints} />
    </>
);

LineEdgeDragPreview.propTypes = {
    elementId: PropTypes.string.isRequired,
    isSelected: PropTypes.bool,
    draggedEdge: PropTypes.string.isRequired,
    hoveredElementId: PropTypes.string,
    offsetDiff: PropTypes.object,

    snapPoints: PropTypes.array,
    dropPosition: PropTypes.object,
};

export default enhance(LineEdgeDragPreview);
